import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { EASE } from "@/lib/scroll";

export default function Aurora() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], ["-10%", "10%"]);

  return (
    <section
      ref={ref}
      data-testid="aurora-section"
      className="relative overflow-hidden bg-[#0B1A10]"
    >
      <motion.img
        src="/photos/aurora.webp"
        alt="Northern Lights dancing over the treetops"
        style={{ y }}
        loading="lazy"
        className="absolute inset-0 h-[120%] w-full object-cover"
      />
      <div className="absolute inset-0 bg-black/45" />
      <div className="relative z-10 mx-auto max-w-7xl px-6 py-28 text-center sm:px-10 sm:py-40">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: EASE }}
        >
          <p className="mb-6 font-mono text-[11px] uppercase tracking-[0.28em] text-[#C8634B]">
            Early & Late Season
          </p>
          <h2 className="font-serif text-3xl tracking-tight text-[#F7F4EF] sm:text-5xl lg:text-6xl">
            The <span className="italic">Northern Lights.</span>
          </h2>
          <p className="mx-auto mt-6 max-w-xl text-sm leading-relaxed text-[#F7F4EF]/85 sm:text-base">
            On clear nights the aurora dances over the lake. Watch from the
            deck, or wander down to the beach for the full show.
          </p>
        </motion.div>
      </div>
    </section>
  );
}
